module.exports = require("lodash/extend");


//////////////////
// WEBPACK FOOTER
// external "lodash/extend"
// module id = 38
// module chunks = 0